import React from "react";
import PropTypes from 'prop-types';
import cx from "classnames";

export const Star = ({percentage}) => {
  const className = cx(
    "stars__star", 
    { [`stars__star--${percentage}`]: percentage > 0 },
  );
  
  return (<span className={className}></span>);
};

Star.propTypes = {
  percentage: PropTypes.number.isRequired,
};